import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSubmitButton = styled(Button)({
  padding: 8,
});
